import {
  DebentureApiResponse,
  RegistroStatus,
  GETCriteriosRemuneracao,
  IndexadorRemuneracao,
  TipoProjecao,
  TipoProRata,
  ConvencaoJurosFixo,
  PagamentoJuros,
  IncorporacaoJuros,
  RegistroResponse,
  AmortizacaoSobre,
  ParticipanteResponse,
  TipoAcessoParticipante,
  EmissaoStatus,
  InstrumentoFinanceiro,
  GETCustoEmissao,
  InicioRentabilidadeEnum
} from 'common/genericTypes';
import moment from 'moment';

const pagamentoJuros: PagamentoJuros = {
  datas: [],
};

const incorporacaoJuros: IncorporacaoJuros = {
  datas: [],
};

const initialCriteriosRemuneracao: GETCriteriosRemuneracao = {
  valorNominalUnitarioEmissao: 0,
  quantidadeEmitida: 0,
  quantidadeDepositada: 0,
  quantidadeRestante: 0,
  volumeEmissao: 0,
  moedaEmissao: '',
  dataEmissao: moment(),
  dataVencimento: moment(),
  cotacaoInicial: 0,
  dataInicioRentabilidade: moment(),
  indexador:
    IndexadorRemuneracao.CDI ||
    IndexadorRemuneracao.IGPM ||
    IndexadorRemuneracao.IPCA ||
    IndexadorRemuneracao.Prefixado ||
    IndexadorRemuneracao.Selic,
  inicioRentabilidade: InicioRentabilidadeEnum.DATA_DE_EMISSAO,
  indexadorPorcentagem: 0,
  proRata: TipoProRata.Corrido || TipoProRata.Util,
  corrigePeriodoFinal: false,
  diaAniversario: 0,
  mesAniversario: 0,
  tipoProjecao: TipoProjecao.Anbima || TipoProjecao.RepeteUltimo,
  taxaJurosFixoSpread: 0,
  convencaoJurosFixos:
    ConvencaoJurosFixo.DCP_360 ||
    ConvencaoJurosFixo.DCP_365 ||
    ConvencaoJurosFixo.DUP_252 ||
    ConvencaoJurosFixo._21_252eDCP_DCT ||
    ConvencaoJurosFixo._21_252xDCP_DCT ||
    ConvencaoJurosFixo._30_360eDCP_DCT ||
    ConvencaoJurosFixo._30_360xDCP_DCT ||
    ConvencaoJurosFixo.Actual30_360 ||
    ConvencaoJurosFixo.Actual360 ||
    ConvencaoJurosFixo.Actual365 ||
    ConvencaoJurosFixo.Business252 ||
    ConvencaoJurosFixo.Month_30 ||
    ConvencaoJurosFixo._30dc,
  saldoDevedorRemanescente: 0,
  precoUnitarioLiquidacao: 0,
  percentualAmortizacaoRemanescente: 100,
  investidoresPrivados: [],
  custoEmissao: {
    feeLaqusBruto: 0
  }
};

export const initialCustoEmissao: GETCustoEmissao = {
  feeLaqusBruto: 0
};

export const initialRegistro: RegistroResponse = {
  id: '',
  ticket: '',
  suspenso: false,
  dataDeCriacao: new Date(),
  status: RegistroStatus.EmAnalise,
};

export const initialEmissor: ParticipanteResponse = {
  id: '',
  ticket: '',
  dataCriacao: moment(),
  tipoAcesso: TipoAcessoParticipante.Participante,
  funcoes: [],
  cnpj: '',
  razaoSocial: '',
  cep: '',
  logradouro: '',
  numero: '',
  complemento: '',
  bairro: '',
  cidade: '',
  uf: '',
  telefones: [],
  atividadePrincipalDesenvolvida: '',
  faturamentoMedioMensalUltimosDozeMeses: 0,
  razaoSocialBancoLiquidante: '',
  ispbBancoLiquidante: '',
  agenciaBancoLiquidante: '',
  contaBancoLiquidante: '',
  registro: initialRegistro,
  representantesLegais: [],
  documentos: [],
  usuarios: [],
  codigo: ''
};

export const initialDebenture: DebentureApiResponse = {
  aditado: false,
  id: 0,
  instrumentoFinanceiroGuid: "",
  debentureId: '',
  ticket: '',
  dataDeCriacao: new Date(),
  emissor: initialEmissor,
  cnpjEmissor: '',
  tipoInstrumentoFinanceiro: InstrumentoFinanceiro.Debenture,
  status:
    RegistroStatus.AguardandoCorrecao ||
    RegistroStatus.Aprovado ||
    RegistroStatus.EmAnalise ||
    RegistroStatus.Reprovado ||
    RegistroStatus.Excluido ||
    RegistroStatus.AguardandoAprovacaoEdicao,
  numeroEmissao: '',
  numeroSerie: '',
  regimeFiduciario: false,
  distribuicaoPublica: false,
  negociacaoSecundariaPor: '',
  escrituraEmissaoFormalizado: false,
  depositariaEmissao: '',
  utilizacaoAnuncioInicioDistribuicao: false,
  ufLocalEmissao: '',
  localEmissao: '',
  classificadoraRisco1: '',
  rating1: '',
  classificadoraRisco2: '',
  rating2: '',
  ufLocalPagamento: '',
  localPagamento: '',
  razaoSocialInstituicaoCustodiante: '',
  cnpjInstituicaoCustodiante: '',
  nomeResponsavelPelasInformacoesDRI: '',
  emailResponsavelPelasInformacoesDRI: '',
  bancoLiquidanteEmissor: '',
  cnpjBancoLiquidanteEmissor: '',
  codigoBancoContaCorrenteVinculadaEmissao: '',
  numeroAgenciaContaCorrenteVinculadaEmissao: '',
  numeroContaCorrenteVinculadaEmissao: '',
  tipoLiquidacao: '',
  descricaoAdicional: '',
  chaveExterna: '',
  isin: '',
  coobrigacao: false,
  naturezaAgenteFiduciario: '',
  razaoSocialAgenteFiduciario: '',
  cpfCnpjAgenteFiduciario: '',
  tipoDistribuicaoPublica: '',
  dataEncerramentoDistribuicao: moment(),
  coordenadores: [],
  coordenadorLider: undefined,
  razaoSocialEscriturador: '',
  cnpjEscriturador: '',
  criteriosRemuneracao: initialCriteriosRemuneracao,
  custoEmissao: initialCustoEmissao,
  amortizacaoSobre: AmortizacaoSobre.Principal,
  amortizacaoPassivelAoTermoSecuritizacao: false,
  amortizacoes: [],
  pagamentoJuros: pagamentoJuros,
  incorporacaoJuros: incorporacaoJuros,
  possuiResgateAntecipado: false,
  documents: [],
  suspenso: false,
  registro: initialRegistro,
  hasPagamentosInadimplentes: false,
  statusEmissao: EmissaoStatus.NaoEmitido,
  codigo: '',
  razaoSocialEmissor: '',
  codigoExterno: '',
  dataUltimaAlteracao: new Date(),
  utilizacaoFaculdadeParagrafo3Art7: false,
};
